import React from 'react';
import i18n from '../../i18n';
import {withFormik} from 'formik';
import axios from 'axios';
import {withStyles} from "@material-ui/core";
import {mergeWithDefault} from "../Form/utils";
import swal from "sweetalert";
import {array, object, string, boolean, required, mixed} from "yup";
import ContractsFormFields from './ContractFormFields'

class ContractForm extends React.Component {

    render() {
        const {
            values,
        } = this.props;


        return <ContractsFormFields {...this.props}/>

    }

}

const FormConfig = withFormik({
    mapPropsToValues: props => {
        return mergeWithDefault(props.values, {
            id_person: props.person.id,
            id_course: '',
            day_contract: '',
            day_contract_start: '',
            day_contract_end: '',
            lessons: '',
            payment: '',
            id_qualification: '',
            person: null,
            course: null,
            qualification: null,
        });
    },

    // validationSchema: () => {
    //     let rules = object().shape({
    //
    //     });
    //
    //     return rules
    // },

    handleSubmit: (values, {props}) => {
        axios.post(props.formUrl, values).then(() => {
            swal({
                icon: "success",
                title: i18n.get('contacts.save_success'),
                text: i18n.get('contacts.you_will_be_redirected'),
                timer: 4000,
            }).then(() => {
                window.location.href = props.redirectAfterSubmit
            })
        }).catch(() => {
            swal({
                icon: "error",
                title: i18n.get('contacts.ajax_error'),
            })
        })
    },

    validateOnBlur: true

})(ContractForm)

const styles = theme => ({
    deleteButton: {
        // background: theme.colors.error
    }
});

export default withStyles(styles)(FormConfig)



// WEBPACK FOOTER //
// ./resources/assets/js/components/Contracts/ContractForm.js